import { mode } from '@chakra-ui/theme-tools';

const disable = {
  _disabled: {
    opacity: '1 !important',
    bg: '#cccccc !important',
    color: '#4C505C !important',
    _hover: {
      bg: '#cccccc !important',
    },
    _active: {
      bg: '#cccccc !important',
    },
    'svg > path': {
      color: '#4C505C !important', 
    }
  },
};

const baseStyle = {
  fontSize: '16px !important',
  w: '100% !important',
  color: 'white !important',
  borderRadius: '30px !important',
  fontWeight: '600',
  lineHeight: '21px',
  letterSpacing: '-0.4px',
  ...disable
};

const buttonStyle = {
  ...baseStyle,
  bg: 'rgb(255, 65, 51) !important',
  _hover: {
    bg: 'rgb(255, 65, 51) !important',
  },
  _active: {
    bg: 'rgb(255, 65, 51) !important',
  },
  _focus: {
    outline: 'unset',
    boxShadow: 'unset'
  }
};

const radiusStyle = {
  ...baseStyle,
  //bg: 'rgb(234, 126, 252) !important',
  bg: 'rgb(255, 65, 51) !important', // TG Color
  borderRadius: '50px',
  _hover: {
    //bg: 'rgb(234, 126, 252) !important',
    bg: 'rgb(255, 65, 51) !important', // TG Color
  },
  _active: {
    //bg: 'rgb(234, 126, 252) !important',
    bg: 'rgb(255, 65, 51) !important', // TG Color
  },
  _focus: {
    outline: 'unset',
    boxShadow: 'unset'
  }
};

const secondaryStyle = {
  ...baseStyle,
  bg: 'rgb(255, 65, 51) !important',
  _hover: {
    bg: 'rgb(255, 65, 51) !important',
  },
  _active: {
    bg: 'rgb(255, 65, 51) !important',
  },
  _focus: {
    outline: 'unset',
    boxShadow: 'unset'
  }
};

const solidStyle = {
  ...baseStyle,
  border: '2px solid rgb(255, 65, 51)',
  backdropFilter: 'blur(2px) !important',
  color: 'rgb(255, 65, 51) !important',
  _hover: {
    bg: 'transparent !important',
  },
  _active: {
    bg: 'transparent !important',
  },
  _focus: {
    outline: 'unset',
    boxShadow: 'unset'
  }
};

const ghostStyle = {
  ...baseStyle,
  border: 'unset !important',
  backdropFilter: 'unset !important',
  bg: 'transparent !important',
  _hover: {
    bg: 'transparent !important',
  },
  _active: {
    bg: 'transparent !important',
  },
  _focus: {
    outline: 'unset',
    boxShadow: 'unset'
  }
};

const stylesLg = {
  h: '56px !important',
  p: '5px 10px',
};

const stylesMd = {
  h: '44px !important',
  p: '5px 10px ',
};

const stylesSm = {
  h: '36px !important',
  p: '8px',
};

const shadowStyle = {
  boxShadow: '0px 1px 22.4px 0px rgba(9, 155, 255, 0.60)'
};

export const buttonStyles = {
  components: {
    Button: {
      variants: {
        'button-lg': {...buttonStyle, ...stylesLg},
        'button-md': {...buttonStyle, ...stylesMd},
        'button-sm': {...buttonStyle, ...stylesSm},
        'radius-lg': {...radiusStyle, ...stylesLg},
        'radius-md': {...radiusStyle, ...stylesMd},
        'radius-sm': {...radiusStyle, ...stylesSm},
        'button-lg-g': {...buttonStyle, ...stylesLg, ...shadowStyle},
        'button-md-g': {...buttonStyle, ...stylesMd, ...shadowStyle},
        'button-sm-g': {...buttonStyle, ...stylesSm, ...shadowStyle},
        'secondary-lg': {...secondaryStyle, ...stylesLg},
        'secondary-md': {...secondaryStyle,...stylesMd},
        'secondary-sm': {...secondaryStyle, ...stylesSm},
        'solid-lg': {...solidStyle, ...stylesLg},
        'solid-md': {...solidStyle,...stylesMd},
        'solid-sm': {...solidStyle, ...stylesSm},
        'ghost-lg': {...ghostStyle, ...stylesLg},
        'ghost-md': {...ghostStyle,...stylesMd},
        'ghost-sm': {...ghostStyle, ...stylesSm},
      },
      baseStyle
    }
  }
};